import { useTranslation } from 'react-i18next';

import { EDripTriggerAction } from '@feathr/blackbox';

type TDripStepActionRecord = Record<EDripTriggerAction, string>;

interface IUseDripTextReturn {
  builder: {
    targetingMessage: TDripStepActionRecord;
    targetingDelayTooltip: TDripStepActionRecord;
    targetingDelayLabel: TDripStepActionRecord;
    targetingDelayHelpText: TDripStepActionRecord;
  };
}

function useDripText(): IUseDripTextReturn {
  const { t } = useTranslation();

  const targetingMessage: TDripStepActionRecord = {
    [EDripTriggerAction.previous_email_delivered]: t('Send to everyone'),
    [EDripTriggerAction.not_opened_previous_email]: t('Not opened the previous email'),
    [EDripTriggerAction.opened_previous_email]: t('Opened the previous email'),
    [EDripTriggerAction.not_clicked_link_previous_email]: t('Not clicked the previous email'),
    [EDripTriggerAction.clicked_link_previous_email]: t('Clicked the previous email'),
  };

  const targetingDelayTooltip: TDripStepActionRecord = {
    [EDripTriggerAction.previous_email_delivered]: t(
      'Set the amount of time that should pass between delivering the previous email and sending this email',
    ),
    [EDripTriggerAction.not_opened_previous_email]: t(
      'Set the amount of time that should pass between delivering the previous email and sending this email',
    ),
    [EDripTriggerAction.opened_previous_email]: t(
      'Set the amount of time that should pass between opening the previous email and sending this email',
    ),
    [EDripTriggerAction.not_clicked_link_previous_email]: t(
      'Set the amount of time that should pass between delivering the previous email and sending this email',
    ),
    [EDripTriggerAction.clicked_link_previous_email]: t(
      'Set the amount of time that should pass between clicking the previous email and sending this email',
    ),
  };

  const targetingDelayLabel: TDripStepActionRecord = {
    [EDripTriggerAction.previous_email_delivered]: t('Delay from delivery'),
    [EDripTriggerAction.not_opened_previous_email]: t('Delay from delivery'),
    [EDripTriggerAction.opened_previous_email]: t('Delay from open'),
    [EDripTriggerAction.not_clicked_link_previous_email]: t('Delay from delivery'),
    [EDripTriggerAction.clicked_link_previous_email]: t('Delay from click'),
  };

  const targetingDelayHelpText: TDripStepActionRecord = {
    [EDripTriggerAction.previous_email_delivered]: t(
      'Set the amount of time that should pass between delivering the previous email and sending this email.',
    ),
    [EDripTriggerAction.not_opened_previous_email]: t(
      'Set the amount of time that should pass between delivering the previous email and sending this email.',
    ),
    [EDripTriggerAction.opened_previous_email]: t(
      'Set the amount of time that should pass between opening the previous email and sending this email.',
    ),
    [EDripTriggerAction.not_clicked_link_previous_email]: t(
      'Set the amount of time that should pass between delivering the previous email and sending this email.',
    ),
    [EDripTriggerAction.clicked_link_previous_email]: t(
      'Set the amount of time that should pass between clicking a link in the previous email and sending this email.',
    ),
  };

  return {
    builder: {
      targetingMessage,
      targetingDelayTooltip,
      targetingDelayLabel,
      targetingDelayHelpText,
    },
  };
}

export default useDripText;
